import { render, staticRenderFns } from "./RouterContainer.vue?vue&type=template&id=502793fe&scoped=true&"
import script from "./RouterContainer.vue?vue&type=script&lang=js&"
export * from "./RouterContainer.vue?vue&type=script&lang=js&"
import style0 from "./RouterContainer.vue?vue&type=style&index=0&id=502793fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502793fe",
  null
  
)

export default component.exports